import { render } from "./step2.vue?vue&type=template&id=8276b80a&ts=true"
import script from "./step2.vue?vue&type=script&lang=ts"
export * from "./step2.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/vivianerbenich/Desktop/git/greeting-card-automation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__